import React, { act, useEffect, useRef, useState, cloneElement } from 'react';
import withAppState from '../mobx/withAppState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faBars } from '@fortawesome/free-solid-svg-icons';
import { Steps } from '../lib/constants';
import dataLayer from '../lib/dataLayer';

const { dataLayerAttribute } = dataLayer;
const { addToDataLayerList } = dataLayer;
const Header = props => {
    const { appPlatform, logo, setAppHeaderHeight, activeStep, restaurant, restaurantUrl } = props;
    const appHeader = useRef();
    const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
    const burger = <FontAwesomeIcon icon={faBars} />
    const [navData, setNavData] = useState([]);

    const getModifiedNavData = (data) => {
        if (!data) return [];
        return data.map(item => {
            if (item.name?.toLowerCase() == 'book') {
                let bookUrl = item.url;
                if (!!restaurant?.restaurantUrlName && activeStep === Steps.PRE_ORDER) {
                    bookUrl = bookUrl + `/${restaurant.restaurantUrlName}/book/book-a-table`;
                } else if (!!restaurantUrl) {
                    bookUrl =  bookUrl +`/${restaurantUrl}/book/book-a-table`;
                } else {
                    bookUrl = bookUrl + `/book/book-a-table-uk`;
                }
                return { ...item, url: bookUrl };
            }
            if (item.name?.toLowerCase() == 'menu') {
                let menuUrl = item.url;
                if (!!restaurant?.restaurantUrlName) {
                    menuUrl = menuUrl + `/${restaurant.restaurantUrlName}/book/book-a-table`;
                } else if (!!restaurantUrl) {
                    menuUrl =  menuUrl +`/${restaurantUrl}/book/book-a-table`;
                } else {
                    menuUrl = menuUrl + `/book/book-a-table-uk`;
                }
                return { ...item, url: menuUrl };
            }
            return item;
        });
    };

    useEffect(() => {
        let isMounted = true;
        async function fetchAPI() {
            try {
                const response = await fetch('api/Menu/NavMenu');
                if (response.status === 200 && isMounted) {
                    const data = await response.json();
                    if (isMounted) {
                        const modifiedData = getModifiedNavData(data);
                        setNavData(modifiedData);
                    }
                }
            } catch (error) {
                console.error('Error fetching nav menu:', error);
            }
        }

        fetchAPI();
        return () => { isMounted = false; };
    }, [restaurant, restaurantUrl, activeStep])

    const handleNavClick = (item) => {
        const itemName = item.name?.toLowerCase();
        
        switch(itemName) {
            case 'book':
                handleBookClick();
                break;
            case 'collection':
                handleOrderClick();
                break;
            case 'delivery':
                handleDeliveryClick();
                break;
            default:
                // For other menu items
                return;
        }
    };
    
    const renderDesktopMenu = () => {
        const desktopItems = navData.filter(item => item.show);
        return desktopItems.map((item, index) => (
            <li key={`desktop-${index}`}>
                <a
                    className="nav-item"
                    href={item.url || '#'}
                    onClick={() => handleNavClick(item)}
                >
                    {item.name}
                </a>
            </li>
        ));
    };
    
    const renderMobileMenu = () => {
        const mobileItems = navData.filter(item => !item.isMobile);
        return mobileItems.map((item, index) => (
            <li key={`mobile-${index}`}>
                <a
                    className="nav-item"
                    href={item.url || '#'}
                    onClick={() => handleNavClick(item)}
                >
                    {item.name}
                </a>
            </li>
        ));
    };
    let menuType = null;

    const handleOutsideClick = (event) => {
        if (!event.target.closest('.active')) {
            setIsBurgerMenuOpen(prev => !prev);
        }
    };
    useEffect(() => {
        if (isBurgerMenuOpen) {
            document.addEventListener('click', handleOutsideClick);
        }
        return () => document.removeEventListener('click', handleOutsideClick);
    }, [isBurgerMenuOpen])

    useEffect(() => {
        if (appHeader.current) {
            setAppHeaderHeight(appHeader.current.clientHeight);
        }

        const updateWindowDimensions = () => {
            if (appHeader.current) {
                setAppHeaderHeight(appHeader.current.clientHeight);
            }
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)

    }, [appHeader.current], []);

    const handleBookClick = (e) => {

        var dataLayerArray = [];

        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_header" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "book_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_header" },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
            );
        }

        addToDataLayerList(dataLayerArray);
    }

    const handleOrderClick = (e) => {

        var dataLayerArray = [];

        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_header" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "order_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_header" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType }
            );
        }

        addToDataLayerList(dataLayerArray);
    }

    const handleDeliveryClick = (e) => {

        var dataLayerArray = [];

        if (menuType === "local menu") {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_header" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
                { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
            );
        }
        else {
            dataLayerArray.push(
                { [dataLayerAttribute.EVENT]: "delivery_link_clicked_header" },
                { [dataLayerAttribute.PAGE_TYPE]: "delivery_link_clicked_header" },
                { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
                { [dataLayerAttribute.MENU_TYPE]: menuType },
            );
        }

        addToDataLayerList(dataLayerArray);

    }

    if (!!appPlatform) return null;
    const newHref = navData.find(item => item.name === 'Home')?.url;
    const updatedLogo =
        React.isValidElement(logo) && newHref
            ? cloneElement(logo, { href: newHref })
            : logo;
    return (
        <header ref={appHeader} className="menu-header">
            <div className="menu-header-inner">
                <div className='header-logo'>
                    {updatedLogo}
                </div>
                <ul className='navigation nav-main hide-mobile'>
                    {renderDesktopMenu()}
                </ul>
                <ul className="navigation justify-content-end">
                    <div>
                        <ul>
                            <li className={`burger-menu burger-container nav-item ${isBurgerMenuOpen ? 'open' : ''}`}>
                                <button
                                    className="nav-item header-burger"
                                    onClick={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
                                >
                                    {burger}
                                </button>
                                {isBurgerMenuOpen && (
                                    <div className="burger-content">
                                        <ul>
                                            {renderMobileMenu()}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>
        </header>
    );
};


export default withAppState(Header, {
    mobXProps: ({
        appPlatform,
        activeStep,
        restaurant,
        restaurantUrl
    }) => ({
        appPlatform,
        activeStep,
        restaurant,
        restaurantUrl
    }),
    mobXActions: ({
        setAppHeaderHeight
    }) => ({
        setAppHeaderHeight
    }),
});
